export const IcpLookupFixture = {
  icp: {
    priceCategoryCode: "GEN",
    gxpNumber: "BRY0661",
    networkCode: "ORON",
    registerContentCodes: ["IN-20"],
  },
};
